import React from "react";
import {
  Check,
  X,
  Sparkle,
  FilePdf,
  LockSimple,
  Signature,
  WhatsappLogo,
  ChatCircleDots,
  CalendarCheck,
  Bell,
  CheckSquare,
} from "@phosphor-icons/react";
import { MOCKUP, SUPPORT_MOCKUP } from "../../data/startPageContent";
import "./StartMiniMockups.css";

/* 1 — calendar events with confirmation chips */
function Confirmations({ services }) {
  const rows = [
    { name: MOCKUP.patientNames[0], svc: services[0], time: "09:00", tone: "blue", state: "ok" },
    { name: MOCKUP.patientNames[1], svc: services[1], time: "10:00", tone: "mint", state: "ok" },
    { name: MOCKUP.patientNames[2], svc: services[2], time: "11:30", tone: "yellow", state: "cancel" },
    { name: MOCKUP.patientNames[3], svc: services[0], time: "13:00", tone: "purple", state: "pending" },
  ];
  return (
    <div className="st-mini st-mini--confirm">
      {rows.map((r) => (
        <div key={r.time} className={`st-mini-ev st-mini-ev--${r.tone}`}>
          <span className="st-mini-ev-time">{r.time}</span>
          <span className="st-mini-ev-body">
            <b>{r.name}</b>
            <small>{r.svc}</small>
          </span>
          {r.state === "ok" && (
            <span className="st-mini-chip st-mini-chip--ok">
              <Check size={11} weight="bold" />
              {MOCKUP.confirmedChip}
            </span>
          )}
          {r.state === "cancel" && (
            <span className="st-mini-chip st-mini-chip--cancel">
              <X size={11} weight="bold" />
              {MOCKUP.cancelledChip}
            </span>
          )}
          {r.state === "pending" && <span className="st-mini-chip st-mini-chip--pending">ממתין</span>}
        </div>
      ))}
    </div>
  );
}

/* 2 — treatment doc card with AI summary button */
function TreatmentDoc({ services }) {
  return (
    <div className="st-mini st-mini--doc">
      <div className="st-mini-doc-head">
        <span className="st-mini-doc-title">סיכום טיפול · {services[0]}</span>
        <span className="st-mini-lock">
          <LockSimple size={11} weight="fill" />
          נעול
        </span>
      </div>
      <div className="st-mini-doc-lines">
        <i style={{ width: "92%" }} />
        <i style={{ width: "78%" }} />
        <i style={{ width: "85%" }} />
        <i style={{ width: "60%" }} />
      </div>
      <div className="st-mini-doc-actions">
        <span className="st-mini-btn st-mini-btn--primary">
          <Sparkle size={12} weight="fill" />
          סיכום AI
        </span>
        <span className="st-mini-btn">
          <FilePdf size={12} />
          ייצוא PDF
        </span>
      </div>
    </div>
  );
}

/* 3 — finance Kanban */
function Kanban() {
  const cols = [
    { title: "ממתין", tone: "yellow", cards: [MOCKUP.patientNames[4], MOCKUP.patientNames[5]] },
    { title: "שולם", tone: "mint", cards: [MOCKUP.patientNames[0], MOCKUP.patientNames[2], MOCKUP.patientNames[6]] },
    { title: "חשבונית", tone: "blue", cards: [MOCKUP.patientNames[1]] },
  ];
  return (
    <div className="st-mini st-mini--kanban">
      {cols.map((c) => (
        <div key={c.title} className="st-mini-col">
          <div className={`st-mini-col-head st-mini-col-head--${c.tone}`}>
            <span>{c.title}</span>
            <em>{c.cards.length}</em>
          </div>
          {c.cards.map((n) => (
            <div key={n} className="st-mini-card">
              <b>{n}</b>
              <small>₪ 350</small>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

/* 4 — phone with signature pad */
function SignaturePad() {
  return (
    <div className="st-mini st-mini--sign">
      <div className="st-mini-phone">
        <div className="st-mini-phone-notch" />
        <p className="st-mini-sign-title">טופס הסכמה מדעת</p>
        <div className="st-mini-sign-lines">
          <i style={{ width: "90%" }} />
          <i style={{ width: "70%" }} />
        </div>
        <div className="st-mini-sign-pad">
          <svg viewBox="0 0 200 60" aria-hidden="true">
            <path d="M12 44 C 30 10, 50 10, 60 40 S 90 60, 105 30 S 140 8, 150 36 S 180 50, 190 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          </svg>
        </div>
        <span className="st-mini-btn st-mini-btn--primary st-mini-sign-btn">
          <Signature size={12} />
          חתימה ושליחה
        </span>
      </div>
    </div>
  );
}

/* 5 — pending-actions cards */
function Pending() {
  const items = [
    { icon: CalendarCheck, text: "3 פגישות ממתינות לאישור", tone: "mint" },
    { icon: Bell, text: "2 תזכורות תשלום לשליחה", tone: "yellow" },
    { icon: CheckSquare, text: "משימה: לעדכן תוכנית טיפול", tone: "blue" },
  ];
  return (
    <div className="st-mini st-mini--pending">
      <p className="st-mini-pending-title">מה ממתין לכם היום</p>
      {items.map(({ icon: Icon, text, tone }) => (
        <div key={text} className="st-mini-pending-item">
          <span className={`st-mini-icon st-mini-icon--${tone}`}>
            <Icon size={14} weight="fill" />
          </span>
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
}

/* 6 — support chat: Lenny answer + human WhatsApp row */
function Support() {
  return (
    <div className="st-mini st-mini--support">
      <div className="st-mini-chat-head">
        <span className="st-mini-icon st-mini-icon--mint">
          <ChatCircleDots size={14} weight="fill" />
        </span>
        <b>{SUPPORT_MOCKUP.botName}</b>
        <span className="st-mini-chip st-mini-chip--ok">{SUPPORT_MOCKUP.online}</span>
      </div>
      <div className="st-mini-bubble st-mini-bubble--user">{SUPPORT_MOCKUP.question}</div>
      <div className="st-mini-bubble st-mini-bubble--bot">{SUPPORT_MOCKUP.answer}</div>
      <div className="st-mini-human">
        <WhatsappLogo size={16} weight="fill" />
        <span>
          {SUPPORT_MOCKUP.humanPrompt} <b>{SUPPORT_MOCKUP.human}</b>
        </span>
      </div>
    </div>
  );
}

/** Picks the mini visual for a feature row (plan §4.3). */
export default function StartMiniMockup({ kind, services }) {
  switch (kind) {
    case "confirmations":
      return <Confirmations services={services} />;
    case "treatmentDoc":
      return <TreatmentDoc services={services} />;
    case "kanban":
      return <Kanban />;
    case "signature":
      return <SignaturePad />;
    case "pending":
      return <Pending />;
    case "support":
      return <Support />;
    default:
      return null;
  }
}
